module.exports = __webpack_public_path__ + "img/collapse-wide.40343520.svg";